import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div style={{ textAlign: 'center', padding: '2rem' }}>
      <h1>404 - Page Not Found</h1>
      <p style={{ marginBottom: '1rem' }}>The page you are looking for does not exist.</p>
      <Link to="/">Return to Dashboard</Link>
    </div>
  );
}
